import React, { useEffect, useState } from 'react';
import { MdArrowOutward } from 'react-icons/md';

const Admission = ({ heading = "Admissions Open for 2026-27 ", onClose }) => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        state: '',
        city: '',
        course: 'B.Tech' // ✅ default set
    });

    const [utmParams, setUtmParams] = useState({
        source: '',
        medium: '',
        campaign: '',
        term: '',
        content: ''
    });

    const [loading, setLoading] = useState(false);

    // ✅ Get UTM + ensure course
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        setUtmParams({
            source: urlParams.get('utm_source') || 'direct',
            medium: urlParams.get('utm_medium') || 'none',
            campaign: urlParams.get('utm_campaign') || 'general',
            term: urlParams.get('utm_term') || '',
            content: urlParams.get('utm_content') || ''
        });

        // ensure course always set
        setFormData(prev => ({ ...prev, course: "B.Tech" }));

    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const getRedirectUrl = () => {
        switch (heading.trim()) {
            case 'Download Brochure':
                return 'https://www.aryacollege.org/wp-content/uploads/2025/04/B.Tech-e-Brochure-1.pdf';
            case 'Download Company List':
            case 'Placement Report':
                return 'https://www.aryacollege.org/our-placements/';
            case 'Book Campus Tour':
                return 'https://www.aryacollege.org/wp-content/uploads/2025/04/Placement-Report.pdf';
            default:
                return 'https://admissions.aryacollege.org/thank-you';
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { name, email, mobile, state, city, course } = formData;

        if (!name || !email || !mobile || !state || !city || !course) {
            alert('Please fill in all the fields.');
            return;
        }

        try {
            setLoading(true);

            const response = await fetch('/api/proxy', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    college_id: 6558,
                    name,
                    email,
                    country_dial_code: '+91',
                    mobile,
                    state,
                    city: formData.city,
                    campus: '',
                    course,
                    source: utmParams.source,
                    medium: utmParams.medium,
                    campaign: utmParams.campaign,
                    term: utmParams.term,
                    content: utmParams.content,
                    // secret_key / access_key are injected server-side by the proxy.
                })
            });

            // Read the body as text first so a non-JSON response (e.g. an HTML
            // error page) does not blow up with "Unexpected token '<'".
            const rawBody = await response.text();
            let data = {};
            try {
                data = rawBody ? JSON.parse(rawBody) : {};
            } catch {
                console.error('Non-JSON response from /api/proxy:', rawBody.slice(0, 200));
                alert('Submission failed: the server returned an unexpected response. Please try again later.');
                return;
            }

            if (response.ok && data.status?.toLowerCase() === 'success') {

                setFormData({
                    name: '',
                    email: '',
                    mobile: '',
                    state: '',
                    city: '',
                    course: 'B.Tech'
                });

                onClose?.();
                window.location.href = getRedirectUrl();

            } else {
                alert(data.message || 'Submission failed. Try again.');
            }

        } catch (error) {
            console.error(error);
            alert('Something went wrong!');
        } finally {
            setLoading(false);
        }
    };

    const statesOfIndia = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
        "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
        "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
        "Uttar Pradesh", "Uttarakhand", "West Bengal"
    ];

    const box = {
        background: "#ffffff", // ✅ fixed
        border: "1px solid #d3d3d3",
        borderRadius: "12px",
        padding: "10px 14px",
        marginBottom: "10px"
    };

    const label = {
        fontSize: "13px",
        color: "#797F86",
        marginBottom: "2px",
        fontWeight: "500"
    };

    const inputRed = {
        width: "100%",
        borderRadius: "10px",
        color: "#5C0102",
        fontSize: "14px",
        outline: "none",
        border: "none",
        background: "#ffffff" // ✅ fixed
    };

    return (
        <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit}>

                <div style={{
                    maxWidth: "420px",
                    margin: "auto",
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #ddd"
                }}>

                    <h4 className="text-center" style={{
                        background: "linear-gradient(90deg, #3E1E1F, #C20204)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontWeight: "600",
                        borderBottom: "2px solid #c94b4b",
                        paddingBottom: "8px",
                        marginBottom: "20px"
                    }}>
                        {heading}
                    </h4>

                    {/* Name */}
                    <div style={box}>
                        <div style={label}>Full Name</div>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} style={inputRed} />
                    </div>

                    {/* Email */}
                    <div style={box}>
                        <div style={label}>Email</div>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputRed} />
                    </div>

                    {/* Mobile */}
                    <div style={box}>
                        <div style={label}>Mobile Number</div>
                        <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            maxLength="10"
                            pattern="[0-9]{10}"
                            style={inputRed}
                        />
                    </div>

                    {/* State + City */}
                    <div className="row">
                        <div className="col-6">
                            <div style={box}>
                                <div style={label}>State</div>
                                <select name="state" value={formData.state} onChange={handleChange} style={inputRed}>
                                    <option value="">Select</option>
                                    {statesOfIndia.map(state => (
                                        <option key={state}>{state}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-6">
                            <div style={box}>
                                <div style={label}>City</div>
                                <input type="text" name="city" value={formData.city} onChange={handleChange} style={inputRed} />
                            </div>
                        </div>
                    </div>

                    {/* Course (Auto) */}
                    <div style={box}>
                        <div style={label}>Course Interested</div>
                        <input value="B.Tech" disabled style={inputRed} />
                    </div>

                    {/* Button */}
                    <div className="text-center mt-3">
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                background: "#e41d1d",
                                border: "none",
                                padding: "10px 26px",
                                borderRadius: "30px",
                                color: "#fff",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                opacity: loading ? 0.7 : 1
                            }}
                        >
                            {loading ? "Submitting..." : "Apply Now"} <MdArrowOutward />
                        </button>
                    </div>

                </div>
            </form>
        </div>
    );
};

export default Admission;